export const AppRoutes = {
  // Home
  home: "/",

  // Mint OAuth redirect
  mintOauthRedirect: "/mint-oauth-redirect",

  // Hidden bridge page embedded by external apps to persist their last auth route
  externalAuthBridge: "/external-auth-bridge",

  // Login
  login: "/login",
  loginCredentials: "/login/credentials",
  loginVerify: "/login/verify",
  authCallbackCognito: "/auth/callback/cognito",
  authCallback: "/auth/callback",
  logout: "/logout",
  recover: "/recover",
  recoverComplete: "/recover-complete",
  resetPassword: "/reset-password",
  resetPasswordComplete: "/reset-password-complete",
  register: "/register",
  registerComplete: "/register-complete",
  confirmEmail: "/user-setting/confirm-email",

  // page not found
  pageNotFound: "/page-not-found",
  externalPageNotFound: "/external-page-not-found",
  serverErrorPage: "/server-error",

  // Maintenance
  maintenance: "/maintenance",

  // Contact
  contact: "/contact",

  // user setting
  userSettingDetail: "/user-setting/detail",
  userSettingEdit: "/user-setting/edit",
  userSettingChangeEmail: "/user-setting/change-email",

  // customer user management (ユーザー管理)
  customerUsers: "/customers",
  customerUserCreate: "/customers/create",
  customerUserDetail: "/customers/:id",
  customerUserEdit: "/customers/:id/edit",
};

/** Builds a concrete customer-user path from the parameterized route. */
export const customerUserPath = {
  detail: (id: number | string) => `/customers/${id}`,
  edit: (id: number | string) => `/customers/${id}/edit`,
};

export const ContactRoutes = [AppRoutes.contact];

export const UserSettingRoutes = [AppRoutes.userSettingDetail, AppRoutes.userSettingEdit, AppRoutes.userSettingChangeEmail];

export const LoginRoutes = [
  AppRoutes.login,
  AppRoutes.loginCredentials,
  AppRoutes.loginVerify,
  AppRoutes.recover,
  AppRoutes.resetPassword,
  AppRoutes.register,
  AppRoutes.confirmEmail,
];

export const ClientRoutes = [AppRoutes.home, ContactRoutes].flat();
